<template>
  <div
    v-if="!props.isLoading"
    id="table-legend-bar"
    class="list-content-wrapper"
    :class="{ 'sticky-legend': legendBarIsInViewport }"
  >
    <v-expansion-panels flat multiple readonly>
      <v-expansion-panel class="list-content-wrapper">
        <v-expansion-panel-header
          hide-actions
          :class="props.flexClass"
          :style="!legendBarIsInViewport ? outOfViewportStyle : ''"
        >
          <div
            v-for="(legend, index) in props.legends"
            :key="`${legend}-${index + 1}`"
            class="table-legend-item-wrapper item-label-flex-unset"
            :style="`flex: ${ props.legendsFlexStructure ? props.legendsFlexStructure[index] : 'inherit'}`"
          >
            <div v-if="props.isLoading" class="item-label-loading">
              <v-skeleton-loader dark type="text" />
            </div>
            <div v-else>
              {{ $t(legend.label) }}
            </div>
          </div>
        </v-expansion-panel-header>
      </v-expansion-panel>
    </v-expansion-panels>
    <div
      v-observe-visibility="visibilityChanged"
      class="legend-viewport-threshold"
    />
  </div>
</template>

<script setup lang="ts">
import './styles/list-legend.scss';

const props = defineProps({
  legends: {
    type: Array<{ label: string, sortable: boolean }>,
    default: []
  },
  isLoading: {
    type: Boolean, default: false
  },
  flexClass: {
    type: String,
    default: ''
  },
  legendsFlexStructure: {
    type: Array<string>,
    default: []
  }
});

let legendBarIsInViewport = false;

const outOfViewportStyle = 'box-shadow: none; background-color: transparent; margin: -1rem 0';

function visibilityChanged(isVisible: boolean) {
  legendBarIsInViewport = !isVisible;
}
</script>
